import Vue from 'vue';
import VueRouter, { NavigationGuard, Route } from 'vue-router';
import routes, {RootName} from './routes';
import {checkLogin} from './utils';
import { Other as terms } from '@/const/terms/mainTerms';
import store from '@/store';
import { cancelAllAPIRequest } from '@/utils/api';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [...routes],
});

export default router;

router.beforeEach(async (to, from, next) => {
        const isLogin = await checkLogin();
        if (to.name !== from.name) {
            await cancelAllAPIRequest(); // warning (Promise overriding)
        }
        switch (to.meta.auth) {
            case 'block':
                if (isLogin) {
                    return next('/');
                }
                break;

            case 'required':
                if (!isLogin) {
                    // Vue.prototype.$notify.closeAll();
                    let returnURL = '';
                    if (to.name !== RootName) { // root name
                        returnURL = '?returnURL=' + encodeURIComponent(to.path);
                    }
                    return next('/login' + returnURL);
                }
                break;
        }
        if (to.meta.title === '') {
            document.title = terms.defaultTitle;
        } else {
            document.title = to.meta.title + terms.defaultSuffix;
        }
        return next();
    },
);
